import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-insert-otp-modal',
    templateUrl: './insert-otp-modal.component.html',
    styleUrls: ['./insert-otp-modal.component.css'],
    standalone: false
})
export class InsertOtpModalComponent implements OnInit {

  @Input() phoneNumber = '';

  constructor(protected activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
